import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { submitCustomerNotification } from "../../../../../api/Api";
import { getFromLocalStorage } from "../../../../../utils/common-utils";

const EditCustomerNotification = ({ editData, onUpdate }) => {
  const [notificationData, setNotificationData] = useState({
    preRenewal: "no",
    preRenewalDays: "",
    renNotify: "yes",
    renNotifyFreq: "OnEveryRenewal",
    cancelNotify: "yes",
    lowBalNotify: "no",
    subNotify: "yes",
  });

  useEffect(() => {
    if (editData) {
      setNotificationData(prev => ({
        ...prev,
        ...editData
      }));
    }
  }, [editData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNotificationData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        userId: getFromLocalStorage("userData")?.id,
        serviceId: editData?.serviceId,
        id: editData?.id,
        preRenewal: notificationData.preRenewal,
        preRenewalDays:
          notificationData.preRenewal === "yes"
            ? notificationData.preRenewalDays
            : null,
        renNotify: notificationData.renNotify,
        renNotifyFreq: notificationData.renNotifyFreq,
        cancelNotify: notificationData.cancelNotify,
        lowBalNotify: notificationData.lowBalNotify,
        subNotify: notificationData.subNotify,
      };

      const response = await submitCustomerNotification(payload);

      if (response?.statusDescription?.status === 200) {
        onUpdate(response.productModel);
        Swal.fire({
          icon: "success",
          text: response?.statusDescription?.description || "Customer notification settings updated successfully!",
        });
      } else {
        Swal.fire({
          icon: "error",
          text: response?.statusDescription?.description || "Failed to update customer notification settings",
        });
      }
    } catch (error) {
      console.error("Error updating customer notification settings:", error);
      Swal.fire({
        icon: "error",
        text: "Failed to update customer notification settings",
      });
    }
  };

  return (
    <div className="tab-content-section">
      {/* <div className="tab-content"> */}
        <div className="tab-pane active">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>
                    Pre-renewal Reminder<span className="text-danger">*</span>
                  </label>
                  <div className="d-flex align-items-center radio_div_span">
                    {/* <div className="form-check mr-3"> */}
                      <input
                        type="radio"
                        className="form-check-input"
                        name="preRenewal"
                        value="yes"
                        checked={notificationData.preRenewal === "yes"}
                        onChange={handleChange}
                        id="preRenewalYes"
                      />
                      {/* <label className="form-check-label" htmlFor="preRenewalYes">Yes</label> */}
                <span className="ml-1">Yes</span>

                    {/* </div> */}
                    {/* <div className="form-check"> */}
                      <input
                        type="radio"
                        // className="form-check-input"
                        name="preRenewal"
                        value="no"
                        checked={notificationData.preRenewal === "no"}
                        onChange={handleChange}
                        id="preRenewalNo"
                  className="ml-3"

                      />
                      {/* <label className="form-check-label" htmlFor="preRenewalNo">No</label> */}
                <span className="ml-1">No</span>

                    {/* </div> */}
                  </div>
                </div>
              </div>

              {notificationData.preRenewal === "yes" && (
                <div className="col-md-6">
                  <div className="form-group">
                    <label>
                      Pre-renewal Reminder Days
                      <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select"
                      name="preRenewalDays"
                      value={notificationData.preRenewalDays}
                      onChange={handleChange}
                      required={notificationData.preRenewal === "yes"}
                    >
                      <option value="">Select Days</option>
                      {[1, 2, 3, 4, 5, 6, 7].map(day => (
                        <option key={day} value={day}>{day}</option>
                      ))}
                    </select>
                   
                  </div>
                </div>
              )}
            </div>

            <div className="row mt-3">
              <div className="col-md-6">
                <div className="form-group">
                  <label>
                    Notify Customer On Renewal<span className="text-danger">*</span>
                  </label>
                  <div className="d-flex align-items-center radio_div_span">
                    {/* <div className="form-check mr-3"> */}
                      <input
                        type="radio"
                        className="form-check-input"
                        name="renNotify"
                        value="yes"
                        checked={notificationData.renNotify === "yes"}
                        onChange={handleChange}
                        id="renNotifyYes"
                      />
                      {/* <label className="form-check-label" htmlFor="renNotifyYes">Yes</label> */}
                <span className="ml-1">Yes</span>

                    {/* </div> */}
                    {/* <div className="form-check"> */}
                      <input
                        type="radio"
                        // className="form-check-input"
                        name="renNotify"
                        value="no"
                        checked={notificationData.renNotify === "no"}
                        onChange={handleChange}
                        id="renNotifyNo"
                  className="ml-3"

                      />
                      {/* <label className="form-check-label" htmlFor="renNotifyNo">No</label> */}
                <span className="ml-1">No</span>

                    {/* </div> */}
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label>
                    Notification Frequency in Renewal
                    <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    name="renNotifyFreq"
                    value={notificationData.renNotifyFreq}
                    onChange={handleChange}
                    required
                  >
                    <option value="OnEveryRenewal">On Every Renewal</option>
                    <option value="Daily">Daily</option>
                    <option value="Weekly">Weekly</option>
                    <option value="Monthly">Monthly</option>
                  </select>
                  
                </div>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-md-4">
                <div className="form-group">
                  <label>
                    Notify Customer On Subscription
                    <span className="text-danger">*</span>
                  </label>
                  <div className="d-flex align-items-center radio_div_span">
                    {/* <div className="form-check mr-3"> */}
                      <input
                        type="radio"
                        className="form-check-input"
                        name="subNotify"
                        value="yes"
                        checked={notificationData.subNotify === "yes"}
                        onChange={handleChange}
                        id="subNotifyYes"
                      />
                      {/* <label className="form-check-label" htmlFor="subNotifyYes">Yes</label> */}
                <span className="ml-1">Yes</span>

                    {/* </div> */}
                    {/* <div className="form-check"> */}
                      <input
                        type="radio"
                        // className="form-check-input"
                        name="subNotify"
                        value="no"
                        checked={notificationData.subNotify === "no"}
                        onChange={handleChange}
                        id="subNotifyNo"
                    className="ml-3"

                      />
                      {/* <label className="form-check-label" htmlFor="subNotifyNo">No</label> */}
                  <span className="ml-1">No</span>

                    {/* </div> */}
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group">
                  <label>
                    Notify Customer On Low Balance
                    <span className="text-danger">*</span>
                  </label>
                  <div className="d-flex align-items-center radio_div_span">
                    {/* <div className="form-check mr-3"> */}
                      <input
                        type="radio"
                        className="form-check-input"
                        name="lowBalNotify"
                        value="yes"
                        checked={notificationData.lowBalNotify === "yes"}
                        onChange={handleChange}
                        id="lowBalNotifyYes"
                      />
                      {/* <label className="form-check-label" htmlFor="lowBalNotifyYes">Yes</label> */}
                  <span className="ml-1">Yes</span>

                    {/* </div> */}
                    {/* <div className="form-check"> */}
                      <input
                        type="radio"
                        // className="form-check-input"
                        name="lowBalNotify"
                        value="no"
                        checked={notificationData.lowBalNotify === "no"}
                        onChange={handleChange}
                        id="lowBalNotifyNo"
                    className="ml-3"

                      />
                      {/* <label className="form-check-label" htmlFor="lowBalNotifyNo">No</label> */}
                  <span className="ml-1">No</span>

                    {/* </div> */}
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group">
                  <label>
                    Notify Customer On Cancellation
                    <span className="text-danger">*</span>
                  </label>
                  <div className="d-flex align-items-center radio_div_span">
                    {/* <div className="form-check mr-3"> */}
                      <input
                        type="radio"
                        className="form-check-input"
                        name="cancelNotify"
                        value="yes"
                        checked={notificationData.cancelNotify === "yes"}
                        onChange={handleChange}
                        id="cancelNotifyYes"
                      />
                      {/* <label className="form-check-label" htmlFor="cancelNotifyYes">Yes</label> */}
                      <span className="ml-1">Yes</span>

                    {/* </div> */}
                    {/* <div className="form-check"> */}
                      <input
                        type="radio"
                        // className="form-check-input"
                        name="cancelNotify"
                        value="no"
                        checked={notificationData.cancelNotify === "no"}
                        onChange={handleChange}
                        id="cancelNotifyNo"
                        className="ml-3"

                      />
                      {/* <label className="form-check-label" htmlFor="cancelNotifyNo">No</label> */}
                      <span className="ml-1">No</span>

                    {/* </div> */}
                  </div>
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-md-12 buttons_divs">
                <button
                  type="submit"
                  className="btn btn-primary float-right"
                >
                  Update Notification Settings
                </button>
              </div>
            </div>
          </form>
        </div>
      {/* </div> */}
    </div>
  );
};

export default EditCustomerNotification;